const { Buffer } = require("buffer/");

window.Buffer = Buffer;
